export default __webpack_public_path__ + "static/media/Win.0d880874.mp3";